import { defineStore } from "pinia";

interface DrawerOptions {
  autoClose?: boolean;
  overlay?: boolean;
  shadow?: boolean;

  [key: string]: any;
}

interface DrawerState {
  activeDrawer: string | null;
  options: DrawerOptions;
}

export const useDrawerStore = defineStore("drawer", {
  state: (): DrawerState => ({
    activeDrawer: null,
    options: {},
  }),
  actions: {
    setActiveDrawer(name: string | null, options?: DrawerOptions) {
      this.activeDrawer = name;
      this.options = options ?? {};

      if (name) {
        document.body.classList.add("is-drawer-open");
      } else {
        document.body.classList.remove("is-drawer-open");
      }
    },
  },
  getters: {
    isDrawerOpen: (state) => state.activeDrawer !== null,
    currentDrawer: (state) => state.activeDrawer,
  },
});
